import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { TransportOption } from '../../transport-options.model';



@Component({
  selector: 'app-constraint-option-assignment-editor',
  templateUrl: './constraint-option-assignment-editor.component.html',
  styleUrls: ['./constraint-option-assignment-editor.component.scss']
})
export class ConstraintOptionAssignmentEditorComponent {

  availableOptions = new Array<TransportOption>();
  assignedOptions = new Array<TransportOption>();

  options = new Array<TransportOption>();

  @Input() set setOptions(options: Array<TransportOption>) {
    this.options = options || new Array<TransportOption>();
    this.setupOptionsSelection();
  }

  @Input() set setAssignedOptions(selectedOptions: Array<TransportOption>) {
    this.assignedOptions = new Array<TransportOption>();
    if (selectedOptions != null) {
      this.assignedOptions.push(...selectedOptions);
    }
    this.setupOptionsSelection();
  }

  @Output() assignedOptionsChanged = new EventEmitter<TransportOption[]>();

  constructor(public translationService: TranslationService) {

  }

  public drop(event: CdkDragDrop<TransportOption[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }

    this.handleAssignedOptionsChanged();
  }

  public dropToAvailableList(event: CdkDragDrop<TransportOption[]>) {
    if (event.previousContainer !== event.container) {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }

    this.handleAssignedOptionsChanged();
  }

  private setupOptionsSelection() {
    if (this.assignedOptions != null && this.options != null) {
      this.availableOptions = new Array<TransportOption>();

      const assignedOptionsById = new Map<number, TransportOption>();

      for (const o of this.assignedOptions) {
        assignedOptionsById.set(o.id, o);
      }

      for (const o of this.options) {
        const assigned = assignedOptionsById.get(o.id);
        if (assigned == null) {
          this.availableOptions.push(o);
        }
      }
    }
    this.availableOptions.sort(this.sortOption.bind(this));
    this.assignedOptions.sort(this.sortOption.bind(this));
  }

  private handleAssignedOptionsChanged() {
    this.assignedOptionsChanged.next(this.assignedOptions);
  }

  private sortOption(a: TransportOption, b: TransportOption) {
    let ta = this.translationService.translate(
      a.name.dictionaryKey
    );
    ta = ta?.toLowerCase();

    let tb = this.translationService.translate(
      b.name.dictionaryKey
    );
    tb = tb?.toLowerCase();

    return ta > tb ? 1 : ta === tb ? 0 : -1;
  }
}
